import React, { useState } from 'react';
import result from 'lodash/result';

import { GenericSpan } from 'commonStyles';
import { TableCell, TableRow } from './index';
import CheckBox from 'common/CheckBoxGrp/CheckBoxGrp';
import { AccordianWrapper, ReportingArrow } from './NestedRow.Styles';

const NestedRow = ({ rowData, handleCheckBoxChange, columns, idKey = 'lineId', bodyRow, bodyRowChild, selectedRecords, index, data, childKey, isOpen }) => {
	const [open, setOpen] = useState(isOpen);
	const handleOpen = () => setOpen((prevState) => !prevState);
	const mainRowProps = rowData?.bodyCellProps || {};

	const getTxt = (actionLength) => `Show history (${actionLength})`;
	return (
		<>
			<TableRow {...bodyRow}>
				{columns.map((column) => {
					const { accessor, bodyCellProps = {}, formatter, checkBoxColumn = false, noExpand } = column;
					const value = !checkBoxColumn && result(rowData, accessor);
					const { bodyCellProps: cellDataProps = {} } = value || {};
					const id = rowData[idKey];

					let isChecked = false;
					if (checkBoxColumn) {
						isChecked = selectedRecords ? !!selectedRecords[id] : rowData.checked;
					}
					const cellProps = { ...mainRowProps, ...bodyCellProps, ...cellDataProps };
					return (
						<TableCell {...cellProps} key={accessor}>
							{checkBoxColumn ? (
								<CheckBox
									item=''
									isChecked={isChecked}
									handleChange={handleCheckBoxChange(false, rowData)}
								/>
							) : formatter ? formatter(value, rowData, index, column, data) : value}
							{rowData[childKey]?.length > 0 && accessor === 'bookingId' && !noExpand &&
								<AccordianWrapper
									onClick={handleOpen} fsize='11px' color='#008ccf' f_weight='700'>
									{getTxt(rowData[childKey].length)}
									<GenericSpan position='relative'>
										<ReportingArrow open={open} border='solid #008CFF' right='-24px' $top={open ? '6px' : '3px'} />
									</GenericSpan>
								</AccordianWrapper>}
						</TableCell>
					);
				})}
			</TableRow>
			{open && rowData[childKey].map((rowChild, i) =>
				<TableRow key={rowChild[idKey]} {...bodyRowChild}>
					{columns.map((column) => {
						const { accessor, bodyCellProps = {}, formatter, checkBoxColumn = false } = column;
						const value = !checkBoxColumn && result(rowChild, accessor);
						const subRowProps = rowChild.bodyCellProps || {};
						const { bodyCellProps: cellDataProps = {} } = value || {};
						const cellProps = { ...mainRowProps, ...subRowProps, ...bodyCellProps, ...cellDataProps };
						const isLast = rowData[childKey]?.length - 1 === i;
						return (
							<TableCell {...cellProps} key={accessor} variant='child' noBdr={isLast ? false : true}>
								{formatter ? formatter(value, rowChild, index, column, data) : value}
							</TableCell>
						);
					})}
				</TableRow>)}
		</>
	);
};

export default NestedRow;
